<template>
  <EditBtn v-bind="$attrs" class="add-btn">
    <slot /> <SvgIcon icon="plus" />
  </EditBtn>
</template>

<script lang="ts" src="./AddBtn.ts"></script>

<style scoped lang="scss" src="./AddBtn.scss"></style>
